<template>
	<!-- Footer -->
	<footer class="iv2-footer theme-b__footer-bg f-14">
		<div class="iv2-footer__container theme-b__footer-text">
			<div class="row">
				<div class="col-xl-6 text-left">
					<div class="row">
						<div v-if="general.logos" class="iv2-footer__logo col-md-4">
							<router-link to="/">
								<img
									:src="general.logos.basic_type2"
									class="iv2-footer__logo-img"
									:alt="general.profile.name + alt_text"
								/>
							</router-link>
						</div>
						<div v-if="general.profile" class="col-md-8">
							<p style="font-size: 14px;" class="m-0">{{ general.profile.name }}</p>
							<p style="font-size: 14px;" class="m-0">{{ "〒" + general.profile.zipcode }}</p>
							<p style="font-size: 14px;" class="m-0">
								{{
								general.profile.address_pref +
								general.profile.address_city +
								general.profile.address_town +
								general.profile.address_build
								}}
							</p>
						</div>
						<p class="col-12 mt-4" style="font-size: 14px;">{{ general.site_description }}</p>
						<div v-if="sns.facebook" class="iv2-footer__sns col-12 d-flex mt-3">
							<span
								v-if="
                                        sns.facebook.status == 0 &&
                                            sns.instagram.status == 0 &&
                                            sns.twitter.status == 0 &&
                                            sns.line.status == 0 &&
                                            rss.outbound.status == 0
                                    "
							></span>
							<span v-else class="size-14 pt-1 mr-3">
								{{
								sns_heading
								}}
							</span>
							<ul class="p-0" style="display: flex; list-style: none;">
								<li v-if="sns.facebook">
									<a
										v-if="sns.facebook.status == 1"
										:href="sns.facebook.url"
										class="iv2-footer__sns-link theme-b__footer-link"
										target="_blank"
										rel="noopener"
									>
										<i class="iv2-footer__sns-icon text-center fab fa-facebook-f"></i>
									</a>
								</li>
								<li v-if="sns.instagram">
									<a
										v-if="sns.instagram.status == 1"
										:href="sns.instagram.url"
										class="iv2-footer__sns-link theme-b__footer-link"
										target="_blank"
										rel="noopener"
									>
										<i class="iv2-footer__sns-icon text-center fab fa-instagram"></i>
									</a>
								</li>
								<li v-if="sns.twitter">
									<a
										v-if="sns.twitter.status == 1"
										:href="sns.twitter.url"
										class="iv2-footer__sns-link theme-b__footer-link"
										target="_blank"
										rel="noopener"
									>
										<i class="iv2-footer__sns-icon text-center fab fa-twitter"></i>
									</a>
								</li>
								<li v-if="sns.line">
									<a
										v-if="sns.line.status == 1"
										:href="sns.line.url"
										class="iv2-footer__sns-link theme-b__footer-link"
										target="_blank"
										rel="noopener"
									>
										<i class="iv2-footer__sns-icon text-center fab fa-line"></i>
									</a>
								</li>
								<li v-if="rss.outbound">
									<a
										v-if="rss.outbound.status == 1"
										:href="rss.outbound.href"
										class="iv2-footer__sns-link theme-b__footer-link"
										target="_blank"
										rel="noopener"
									>
										<i class="iv2-footer__sns-icon text-center fas fa-rss"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="iv2-footer__nav col-xl-6 text-left">
					<div class="d-flex">
						<p class="mt-0">{{ menu_title }}</p>
						<hr class="theme-b__footer-hr m-3" style="width: 100%;" />
					</div>
					<ul class="iv2-footer__nav-list">
						<li v-for="nav in footer_menu.slice(0, 18)" :key="nav.id" class="iv2-footer__nav-item">
							<router-link
								v-if="nav.link_type == 'internal'"
								:to="nav.url"
								class="iv2-footer__nav-link theme-b__footer-link"
							>{{ nav.name }}</router-link>
							<a
								v-else-if="nav.link_type == 'external'"
								v-bind:href="nav.url"
								:target="nav.target_type"
								rel="noopener"
								class="iv2-footer__nav-link theme-b__footer-link"
							>{{ nav.name }}</a>
							<ul v-if="!nav.children.length == false" class="iv2-footer__nav-list list-unstyled">
								<li v-for="cNav in nav.children" :key="cNav.id" class="iv2-footer__nav-item">
									<router-link
										v-if="cNav.link_type == 'internal'"
										:to="cNav.url"
										class="iv2-footer__nav-link theme-b__footer-link"
									>{{ cNav.name }}</router-link>
									<a
										v-else-if="
                                                cNav.link_type == 'external'
                                            "
										:href="cNav.url"
										@click="activeMenu = false"
										:target="cNav.target_type"
										rel="noopener"
										class="iv2-footer__nav-link theme-b__footer-link"
									>{{ cNav.name }}</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
			<hr class="iv2-footer__hr theme-b__footer-hr" />
			<div class="iv2-footer__copyright text-center">
				<small class="copyright text-center">
					{{
					general.copyright
					}}
				</small>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	data() {
		return {
			general: [],
			footer_menu: [],
			sns: [],
			rss: [],

			sns_heading: "FOLLOW ME",
			menu_title: "MENU",
			alt_text: "のロゴ",
		};
	},

	created() {
		this.axios.get("/json/navigations.json").then((response) => {
			this.footer_menu = response.data.navs.footer_menu;
		});
		this.axios.get("/json/settings.json").then((response) => {
			this.general = response.data.settings.general;
			this.sns = response.data.settings.sns;
		});
		this.axios.get("/json/rss.json").then((response) => {
			this.rss = response.data.rss;
		});
	},
};
</script>

<style lang="scss">
.iv2-footer__container {
	width: 85%;
	margin: auto;

	.iv2-footer__logo {
		text-align: center;

		.iv2-footer__logo-img {
			max-height: 150px;
		}
	}

	.iv2-footer__nav {
		word-break: initial;

		.iv2-footer__nav-list {
			display: flex;
			flex-wrap: wrap;
			padding: 0;

			.iv2-footer__nav-item {
				font-size: 16px;
				display: block;
				width: 33.3%;

				.iv2-footer__nav-link {
					padding-right: 10px;
					display: block;
					text-decoration: none;

					&::before {
						content: "-";
						margin-right: 5px;
					}
				}

				> .iv2-footer__nav-list {
					display: block;
					margin-top: 0px;
					margin-bottom: 15px;
					margin-right: 0px;
					padding-top: 0;
					padding-left: 0;
					border-left: 0;

					.iv2-footer__nav-item {
						font-size: 14px;
						margin-bottom: 0;
						width: 100%;

						.iv2-footer__nav-link {
							margin-left: 15px;
							margin-bottom: 0;
							line-height: 1.7;
						}
					}
				}
			}
		}
	}

	.iv2-footer__sns {
		.iv2-footer__sns-link {
			margin-right: 15px;

			.iv2-footer__sns-icon {
				width: 15px;
			}
		}
	}

	.iv2-footer__hr {
		padding: 0;
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-footer {
		padding: 50px 0;
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
	.iv2-footer {
		padding: 20px 0;
	}

	.iv2-footer__container {
		.iv2-footer__hr {
			margin: 10px 0;
		}
	}
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-footer {
		margin-bottom: 70px;
		padding-bottom: calc(env(safe-area-inset-bottom));
	}

	.iv2-footer__container {
		padding-bottom: 20px;

		.iv2-footer__logo {
			margin: 25px auto;

			.iv2-footer__logo-img {
				max-width: 80%;
			}
		}

		.iv2-footer__nav {
			display: none;
		}
	}
}
</style>
